/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import _ from 'lodash';
import React,{ useState,useEffect,useRef } from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import { connect } from 'react-redux';
import { StyledForm } from '../CSS/style';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import StyledTable from '../../../commons/styles/table';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { IPAddress, MODELCOMPARSION, RBSLOOKUPMaster, RBSPREDMODEL } from '../../../commons/api';
import { ApartmentOutlined, DownOutlined, SearchOutlined, SmileOutlined } from '@ant-design/icons';
import {
  DeployModel,
  getDeployHistory,
  getList,
  getMetaData,
  createPredictionRequests
} from '../Utils/FormCalls';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tree,
  message,
  Image,
  Tabs,
  Typography,
  Popconfirm,
  Layout,
  Result
} from 'antd';
import {
  StyledBox,
  StyledBoxLabel,
  StyledModal,
  StyledSubHeading,
} from '../CSS/style';
const { Header, Content } = Layout;
const { TabPane } = Tabs;
const { TextArea } = Input;
const APIList = {
  getList: `${RBSPREDMODEL.ModelWorkBenchList}`,
  getPredictionHistory: `${RBSPREDMODEL.CompletedPredictionRequestList}`,
  batchPredData: `${RBSPREDMODEL.PredictionReqlist}`,
  getDeployHistory: `${RBSPREDMODEL.DeployemtReqlist}`,
  getData: `${RBSPREDMODEL.ReadMetadata}`,
  getMetrics: `${RBSLOOKUPMaster.LookUpItemsGetById}`,
  getMetricResults: `${RBSPREDMODEL.MetricpRedList}`,
  predictionRequest: `${IPAddress.PREDICTIONIP}/pred_reqs/create_request`,
  bookmarkCreate: `${MODELCOMPARSION.CREATE}`,
  getDataByBookmark: `${MODELCOMPARSION.GetById}`
};
const { Option } = Select;
const { TreeNode } = Tree;
const { Title } = Typography;
const Model_Comparision = (props) => {
  const [formObject, setFormObject] = useState({});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [modelsList, setModelsList] = useState([]);
  const [filteredArrayOfModels_1, setFilteredArrayOfModels_1] = useState([]);
  const [model_1PredictionRequestList, setModel_1PredictionRequestList] = useState([]);
  const [filteredArrayOfModels_2, setFilteredArrayOfModels_2] = useState([]);
  const [model_2PredictionRequestList, setModel_2PredictionRequestList] = useState([]);
  const [model_1MetricValuesData, setModel_1MetricValuesData] = useState([]);
  const [predictionModel_1, setPredictionModel_1] = useState(false);
  const [model_1MetricImagesData, setModel_1MetricImagesData] = useState([]);
  const [predictionModel_2, setPredictionModel_2] = useState(false);
  const [model_2MetricImagesData, setModel_2MetricImagesData] = useState([]);
  const [newPredictionModel_1, setNewPredictionModel_1] = useState(false);
  const [model_2MetricValuesData, setModel_2MetricValuesData] = useState([]);
  const [newPredictionModel_2, setNewPredictionModel_2] = useState(false);
  const [metricsData, setMetricsData] = useState([]);
  const [model_1Info, setModel_1Info] = useState({});
  const [searchedColumn, setSearchedColumn] = useState([]);
  const [model_2Info, setModel_2Info] = useState({});
  const [searchText, setSearchText] = useState([]);
  const [showResults, setShowResults] = useState(false);
  //const [modelSelectionPopup, setModelSelectionPopup] = useState(false);
  //const [selectionType, setSelectionType] = useState('radio');
  const [modelDeployHistoryData_1, setModelDeployHistoryData_1] = useState({});
  const [modelDeployHistoryData_2, setModelDeployHistoryData_2] = useState({});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  const [selectedRowKeys1, setSelectedRowKeys1] = useState([]);
  const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
  //const [activekey_1, setActiveKey1] = useState('1');
  const [BookmarkId, setBookmarkId] = useState('');
  const dataRef = useRef(null);
  const modelRef = useRef();
  const model_1Ref = useRef();
  const model_2Ref = useRef();
  const model_1Button = useRef();
  const model_2Button = useRef();
  const model_1tab2Confirm = useRef();
  const model_2tab2Confirm = useRef();
  const model_1tab1Confirm = useRef();
  const model_2tab1Confirm = useRef();
  // const TaskRef = useRef();
  const searchInput = useRef();
  useEffect(() => {
    const fetchData = async () => {
      const path = props.location.pathname.split('/rubus/RbsAnalytics/ModelComparision/');
      const Id = path[1] && base64_decode(path[1]) ? base64_decode(path[1]) : null;
      const response = await getList(APIList.getList);
      const modelsList = response && Array.isArray(response) ? [...response] : [];
      setModelsList(modelsList);
      setFilteredArrayOfModels_1(response && Array.isArray(response) ? [...response] : []);
      setFilteredArrayOfModels_2(response && Array.isArray(response) ? [...response] : []);
      if (props.location.state === null) {
        if (Id) {
          const model_1response = {};
          const model_2response = {};
          const data = await getMetaData(APIList.getDataByBookmark, 'Id', Id);
          const model_1Info = {
            ...(data && data.model_1),
            FromTime: moment.utc(data.model_1.FromTime, 'YYYY-MM-DD HH:mm:ss'),
            ToTime: moment.utc(data.model_1.ToTime, 'YYYY-MM-DD HH:mm:ss')
          };
          const model_2Info = {
            ...(data && data.model_2),
            FromTime: moment.utc(data.model_2.FromTime, 'YYYY-MM-DD HH:mm:ss'),
            ToTime: moment.utc(data.model_2.ToTime, 'YYYY-MM-DD HH:mm:ss')
          };
          const formObject = {
            ModelName_1: data.model_1?.ModelName_1 || '',
            ModelName_2: data.model_2?.ModelName_2 || '',
            comments: data.comments || ''
          };
          if (model_1Info.PredReqId_1) {
            const model_1response = await getDeployHistory(APIList.getMetricResults, 'PredReqId', model_1Info.PredReqId_1);
            setModel_1MetricValuesData(model_1response && model_1response.TableList ? model_1response.TableList : null,
            );
            setModel_1MetricImagesData(model_1response.ImageList && model_1response.ImageList
              ? model_1response.ImageList
              : null);
          }
          if (model_2Info.PredReqId_2) {
           const  model_2response = await getDeployHistory(APIList.getMetricResults, 'PredReqId', model_2Info.PredReqId_2);
           setModel_2MetricValuesData(model_2response && model_2response.TableList ? model_2response.TableList : null,
           );
           setModel_2MetricImagesData(model_2response.ImageList && model_2response.ImageList
             ? model_2response.ImageList
             : null);
          }
           // model_1Ref.current.setFieldsValue({ model_1Info });
            //   model_2Ref.current.setFieldsValue({ model_2Info });
          dataRef.current && dataRef.current.setFieldsValue(formObject);
          setModel_1Info(model_1Info);
          setModel_2Info(model_2Info);
          setFormObject(formObject);
          setSelectedRowKeys1(data.model_1?.PredReqId_1 ? [data.model_1.PredReqId_1] : []);
          setSelectedRowKeys2(data.model_2?.PredReqId_2 ? [data.model_2.PredReqId_2] : []);
         

          setShowResults(true);
          onHandleChange('ModelName_1', data.model_1?.ModelName_1, model_1Info);
          onHandleChange('ModelName_2', data.model_2?.ModelName_2, model_2Info);
        } else {
          setModelsList(response && Array.isArray(response) ? [...response] : []);
        }
      } else if (props.location.state.ModelName_1 && props.location.state.PredReqId_1) {
        const  data = response.filter(item => item.ModelName === props.location.state.ModelName_1);
        const  model_1Info = {
          ModelName_1: data[0]?.ModelId || '',
          PredReqId_1: props.location.state.PredReqId_1,
          FromTime: props.location.state.FromTime || '',
          ToTime: props.location.state.ToTime || ''
        };
        const  formObject = {
          ModelName_1: data[0]?.ModelId || ''
        };
        onHandleChange('ModelName_1', data[0]?.ModelId, model_1Info, modelsList);
        dataRef.current.setFieldsValue(formObject );
        setModel_1Info(model_1Info);
        setFormObject(formObject);
        setSelectedRowKeys1([props.location.state.PredReqId_1]);
      }
    };
    fetchData();
  }, [props.location.pathname]);
  useEffect(() => {
    if (props.userProfile !== userProfile || props.translationCache !== translationCache) {
      setUserProfile(props.userProfile);
      setTranslationCache(props.translationCache);
    }
  }, [props.userProfile, props.translationCache]);
  const onHandleChange = async (key, value, model_Info, list) => {
    const model_1Info = {};
    const model_2Info = {};
    if (key === 'ModelName_1') {
      const model_1PredictionRequestList = await getDeployHistory(APIList.getPredictionHistory, 'ModelId', value);
      if (props.location.state?.ModelName_1 && props.location.state?.PredReqId_1) {
        list &&
        list.map(item => {
          if (item.ModelId === value) {
            const arrayofdata = list.filter(item1 => item1.TargetParameter === item.TargetParameter);
          }
        });
      } else {
        modelsList &&
        modelsList.map(item => {
          if (item.ModelId === value) {
           const  arrayofdata = modelsList.filter((item1) => item1.TargetParameter === item.TargetParameter);
           setFilteredArrayOfModels_2(arrayofdata);

          }
        });
      }
      const model_1Info = { ...model_Info, [key]: value };
      model_1Ref.current && model_1Ref.current.setFieldsValue(model_1Info );
      setModel_1Info(model_1Info);
      setModel_1PredictionRequestList(model_1PredictionRequestList);
    } else if (key === 'ModelName_2') {
      var model_2PredictionRequestList = await getDeployHistory(APIList.getPredictionHistory, 'ModelId', value);
      modelsList &&modelsList.forEach(item => {
        if (item.ModelId === value) {
         const  arrayofdata = modelsList.filter(item1 => item1.TargetParameter === item.TargetParameter);
         setFilteredArrayOfModels_1(arrayofdata);

        }
      });
      const Model_2Info = { ...model_Info, [key]: value };
      model_2Ref.current && model_2Ref.current.setFieldsValue(Model_2Info );
      setModel_2Info(Model_2Info);
      setModel_2PredictionRequestList(model_2PredictionRequestList);
    }
    dataRef.current && dataRef.current.setFieldsValue(model_1Info, model_2Info );
    setFormObject({ ...model_1Info, ...model_2Info });
  };
        // const default_1DeployConfirm = (record) => {
        //   const formObject = {
        //     ...formObject,
        //     PredReqId_1: record.PredReqId
        //   };
        //   let model_1Info = {
        //     ...model_1Info,
        //     PredReqId: record.PredReqId
        //   };
        //   model_1Ref.current && model_1Ref.current.setFieldsValue({ ...model_1Info });
        //   dataRef.current && dataRef.current.setFieldsValue({ ...formObject });
        //   setModel_1Info(model_1Info);
        //   setFormObject(formObject);
        // };
          // const default_2DeployConfirm = (record) => {
          //   let formObject = {
          //     ...formObject,
          //     PredReqId_2: record.PredReqId
          //   };
          //   let model_2Info = {
          //     ...model_2Info,
          //     PredReqId: record.PredReqId
          //   };
          //   model_2Ref.current && model_2Ref.current.setFieldsValue(model_2Info);
          //   dataRef.current && dataRef.current.setFieldsValue({ ...formObject });
          //   setModel_2Info(model_2Info);
          //   setFormObject(formObject);
          // };
  const renderTreeNodes = (data) => {
    return (
      data && Array.isArray(data) && data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode title={item.key} key={item.key} dataRef={item.key}>
              {renderTreeNodes(item.children,item)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.value} title={item.key} dataRef={item.value} />;
      })
    );
  };
  const getDeployHistory1 = async (Model_Id) => {
    const ModelDeployHistoryData = await getDeployHistory(
      APIList.getDeployHistory,
      'ModelId',
      Model_Id
    );
    return ModelDeployHistoryData;
  };
  const getModel_1MetaData = async (Model_Id) => {
    const modelDetails = await getMetaData(APIList.getData, 'ModelId', Model_Id);
    const modelDeployHistoryData_1 = await getDeployHistory1(Model_Id);
    const modeltype =
      modelDetails && modelDetails.ModelType === 'Classification'
        ? 'RBS_MODEL_CLF_METRICS'
        : modelRef.current && modelRef.current.getFieldValue('ModelType') === 'Regression'
          ? 'RBS_MODEL_REG_METRICS'
          : null;
    var metricsData = await getDeployHistory(APIList.getMetrics, 'LookupName', modeltype);
    const deploymentData =
      modelDeployHistoryData_1 &&
      modelDeployHistoryData_1.filter((item) => item.Default === true) &&
      modelDeployHistoryData_1.filter((item) => item.Default === true)[0];
      let DeploymentData = {};
    if (deploymentData) {
       DeploymentData = {
        CreatedTime: moment(deploymentData.CreatedTime).utc().local().format('YYYY-MM-DD HH:mm:ss'),
        Virtualenv: deploymentData.Virtualenv
      };
    }
    _.cloneDeepWith(modelDetails, (value) => {
      return value !== null && value !== undefined
        ? {
          ...value,
          ...(value['TrainPeriodFrom'] ? (value['TrainPeriodFrom'] = moment(value.TrainPeriodFrom).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['TrainPeriodTo'] ? (value['TrainPeriodTo'] = moment(value.TrainPeriodTo).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['EvalPeriodFrom'] ? (value['EvalPeriodFrom'] = moment(value.EvalPeriodFrom).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['EvalPeriodTo'] ? (value['EvalPeriodTo'] = moment(value.EvalPeriodTo).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['CreatedTime'] ? (value['CreatedTime'] = moment(value.CreatedTime).utc().local().format('YYYY-MM-DD HH:mm:ss')) : null)
        }
        : _.noop();
    });
    const ModelDetails = {
    ModelName_1: model_1Info.ModelName_1 ? model_1Info.ModelName_1 : '',
      ...modelDetails,
      ...DeploymentData,
      Metrics: metricsData && Array.isArray(metricsData) ? metricsData.map((item) => item.value) : []
    };
    model_1Ref.current && model_1Ref.current.setFieldsValue(ModelDetails );
    setModel_1Info(ModelDetails);
    setNewPredictionModel_1(true);
    setMetricsData(metricsData);
    setModelDeployHistoryData_1(modelDeployHistoryData_1);
  };
  const getModel_2MetaData = async (Model_Id) => {
    const modelDetails = await getMetaData(APIList.getData, 'ModelId', Model_Id);
    const modelDeployHistoryData_2 = await getDeployHistory1(Model_Id);
    const modeltype =
      modelDetails && modelDetails.ModelType === 'Classification'
        ? 'RBS_MODEL_CLF_METRICS'
        : modelRef.current && modelRef.current.getFieldValue('ModelType') === 'Regression'
          ? 'RBS_MODEL_REG_METRICS'
          : null;
    var metricsData = await getDeployHistory(APIList.getMetrics, 'LookupName', modeltype);
    const deploymentData =
      modelDeployHistoryData_2 &&
      modelDeployHistoryData_2.filter((item) => item.Default === true) &&
      modelDeployHistoryData_2.filter((item) => item.Default === true)[0];
      let DeploymentData = {};
    if (deploymentData) {
       DeploymentData = {
        CreatedTime: moment(deploymentData && deploymentData.CreatedTime).utc().local().format('YYYY-MM-DD HH:mm:ss'),
        Virtualenv: deploymentData &&deploymentData.Virtualenv
      };
    }
    _.cloneDeepWith(modelDetails, (value) => {
      return value !== null && value !== undefined
        ? {
          ...value,
          ...(value['TrainPeriodFrom'] ? (value['TrainPeriodFrom'] = moment(value.TrainPeriodFrom).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['TrainPeriodTo'] ? (value['TrainPeriodTo'] = moment(value.TrainPeriodTo).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['EvalPeriodFrom'] ? (value['EvalPeriodFrom'] = moment(value.EvalPeriodFrom).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['EvalPeriodTo'] ? (value['EvalPeriodTo'] = moment(value.EvalPeriodTo).utc().format('YYYY-MM-DD HH:mm:ss')) : null),
          ...(value['CreatedTime'] ? (value['CreatedTime'] = moment(value.CreatedTime).utc().local().format('YYYY-MM-DD HH:mm:ss')) : null)
        }
        : _.noop();
    });
   const  ModelDetails = {
      ModelName_2: model_2Info.ModelName_2 || '',
      ...modelDetails,
      ...DeploymentData,
      Metrics: metricsData && Array.isArray(metricsData) ? metricsData.map((item) => item.value) : []
    };
    model_2Ref.current && model_2Ref.current.setFieldsValue(ModelDetails );
    setModel_2Info(ModelDetails);
    setNewPredictionModel_2(true);
    setMetricsData(metricsData);
    setModelDeployHistoryData_2(modelDeployHistoryData_2);
  };
          // const getDisabledHoursTask = (e, key) => {
          //   const hours = [];
          //   let minutes = [];
          //   let StartDateTime = '';
          //   let EndDateTime = '';
          //   let StartDate = '';
          //   let EndDate = '';
          //   if (key === 'StartTime') {
          //     StartDateTime = moment(e).format('YYYY-MM-DD HH:mm');
          //     EndDateTime = moment.utc(TaskRef.current.getFieldValue('EndTime'), 'YYYY-MM-DD HH:mm').local();
          //     StartDate = moment(e).format('YYYY-MM-DD');
          //     EndDate = moment.utc(TaskRef.current.getFieldValue('EndTime')).local().format('YYYY-MM-DD');
          //   } else if (key === 'EndTime') {
          //     StartDate = moment
          //       .utc(
          //         TaskRef.current.getFieldValue() && TaskRef.current.getFieldValue('StartTime')
          //       )
          //       .local()
          //       .format('YYYY-MM-DD');
          //     EndDate = moment(e).format('YYYY-MM-DD');
          //   }
          //   if (key === 'StartTime' && moment(StartDate).isSame(moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours())) {
          //     for (let i = 0; i <= 24; i++) {
          //       if (i > moment(EndDateTime).hours()) {
          //         hours.push(i);
          //       }
          //     }
          //     if (moment(StartDate).isSame(moment(EndDate))) {
          //       for (var i = 0; i <= 60; i++) {
          //         if (i > moment(EndDateTime).minutes() - 1) {
          //           minutes.push(i);
          //         }
          //       }
          //     }
          //     return {
          //       disabledHours: () => hours,
          //       disabledMinutes: () => minutes
          //     };
          //   } else if (key === 'EndTime' && moment(StartDate).isSame(moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours())) {
          //     for (let i = 0; i < moment(StartDateTime).hours(); i++) {
          //       if (i < 25) {
          //         hours.push(i);
          //       }
          //     }
          //     if (moment(StartDate).isSame(moment(EndDate))) {
          //       for (let i = 0; i < moment(StartDateTime).minutes() + 1; i++) {
          //         if (i < 61) {
          //           minutes.push(i);
          //         }
          //       }
          //     }
          //     return {
          //       disabledHours: () => hours,
          //       disabledMinutes: () => minutes
          //     };
          //   }
          // };
  const handleDateInputChange = (dateString) => {
    const data = model_1Ref.current && model_1Ref.current.getFieldsValue();
    const TrainedFrom = data && data.TrainPeriodFrom;
    const TrainedTo = data && data.TrainPeriodTo;
    const date = dateString && dayjs(dateString).format('YYYY-MM-DD HH:mm:ss');
    if (date >= TrainedFrom && date <= TrainedTo) {
      message.error(
        'This date range overlaps with model training period. The prediction results may not reflect the accuracy of the unseen data. Do you want to continue?'
      );
    } else {
      return null;
    }
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation('Search') + translation(dataIndex)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: '5px' }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
{/* <Button
          type="link"
          
          onClick={() => {
            confirm({
              closeDropdown: false,
            });
            setState({
              searchText: selectedKeys[0],
              searchedColumn: dataIndex,
            });
          }}
        >
          Filter
        </Button> */}
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };
  const onFormCompare = async () => {
    if (dataRef.current) {
      try {
        await dataRef.current.validateFields();

        if (model_1Info && model_1Info !== undefined) {
        const  model_1response = await getDeployHistory(
            APIList.getMetricResults,
            'PredReqId',
            model_1Info.PredReqId_1
          );
          setModel_1MetricValuesData(model_1response?.TableList || null);
          setModel_1MetricImagesData(model_1response?.ImageList || null);
        }
        if (model_2Info && model_2Info.PredReqId_2) {
        const  model_2response = await getDeployHistory(
            APIList.getMetricResults,
            'PredReqId',
            model_2Info.PredReqId_2
          );

        setModel_2MetricValuesData(model_2response?.TableList || null);
        setModel_2MetricImagesData(model_2response?.ImageList || null);
        }

        setShowResults(true);
      } catch (error) {
        console.error(error);
      }
    }
  };
  const onFormSaveCompare = async () => {
    const formObject = dataRef.current.getFieldsValue();
    const { model_1PredictionRequestList, model_2PredictionRequestList } = props; // Assuming these are passed as props
    if (dataRef.current) {
      try {
        await dataRef.current.validateFields();
        if (!model_1Info.PredReqId_1 && !model_2Info.PredReqId_2) {
          modelsSave(model_1Info, model_2Info);
        } else {
          if (!model_1Info.PredReqId_1 && model_2Info.PredReqId_2) {
            modelSave(model_1Info, 'model__1');
          } else if (!model_2Info.PredReqId_2 && model_1Info.PredReqId_1) {
            modelSave(model_2Info, 'model__2');
          } else {
            if (model_2Info &&model_2Info.PredReqId_2 && model_1Info &&model_1Info.PredReqId_1) {
              const final = {
                model_1: {
                  ...model_1Info,
                  FromTime:
                  model_1Info && model_1Info.FromTime && model_1Info.FromTime !== undefined
                    ? dayjs(model_1Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss')
                    : model_1PredictionRequestList &&
                      model_1PredictionRequestList.filter(
                        (item) => item.PredReqId === model_1Info.PredReqId_1
                      ) &&
                      model_1PredictionRequestList.filter(
                        (item) => item.PredReqId === model_1Info.PredReqId_1
                      )[0] &&
                      model_1PredictionRequestList.filter(
                        (item) => item.PredReqId === model_1Info.PredReqId_1
                      )[0]['FromTime']
                      ? dayjs(
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        )[0]['FromTime']
                      )
                        .utc()
                        .format('YYYY-MM-DD HH:mm:ss')
                      : null,
                ToTime:
                  model_1Info && model_1Info.ToTime && model_1Info.ToTime !== undefined
                    ? moment(model_1Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss')
                    : model_1PredictionRequestList &&
                      model_1PredictionRequestList.filter(
                        (item) => item.PredReqId === model_1Info.PredReqId_1
                      ) &&
                      model_1PredictionRequestList.filter(
                        (item) => item.PredReqId === model_1Info.PredReqId_1
                      )[0] &&
                      model_1PredictionRequestList.filter(
                        (item) => item.PredReqId === model_1Info.PredReqId_1
                      )[0]['ToTime']
                      ? moment(
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        )[0]['ToTime']
                      )
                        .utc()
                        .format('YYYY-MM-DD HH:mm:ss')
                      : null
              },
                model_2: {
                  ...model_2Info,
                  FromTime:
                  model_2Info && model_2Info.FromTime && model_2Info.FromTime !== undefined
                    ? moment(model_2Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss')
                    : model_2PredictionRequestList &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      ) &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      )[0] &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      )[0]['FromTime']
                      ? moment(
                        model_2PredictionRequestList.filter(
                          (item) => item.PredReqId === model_2Info.PredReqId_2
                        )[0]['FromTime']
                      )
                        .utc()
                        .format('YYYY-MM-DD HH:mm:ss')
                      : null,
                ToTime:
                  model_2Info && model_2Info.FromTime && model_2Info.FromTime !== undefined
                    ? moment(model_2Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss')
                    : model_2PredictionRequestList &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      ) &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      )[0] &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      )[0]['ToTime']
                      ? moment(
                        model_2PredictionRequestList.filter(
                          (item) => item.PredReqId === model_2Info.PredReqId_2
                        )[0]['ToTime']
                      )
                        .utc()
                        .format('YYYY-MM-DD HH:mm:ss')
                      : null
                },
                comments:
                formObject.comments && formObject.comments !== undefined
                  ? formObject.comments
                  : ''
              };
              await bookmarkCreate(final, model_1Info, model_2Info);
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  const bookmarkCreate = async (final, model_1Info, model_2Info) => {
    let path = props.location.pathname.split('/rubus/RbsAnalytics/ModelComparision/');
    let Id = path[1] && base64_decode(path[1]) ? base64_decode(path[1]) : null;
    if (Id) {
      final = { ...final, Id };
    }
    let response = await DeployModel(APIList.bookmarkCreate, final);
    message.success(response?.message && translation(response.message));
    const  model_1response = await getDeployHistory(
      APIList.getMetricResults,
      'PredReqId',
      model_1Info.PredReqId_1
    );
    const  model_2response = await getDeployHistory(
      APIList.getMetricResults,
      'PredReqId',
      model_2Info.PredReqId_2
    );
    setModel_1MetricValuesData(model_1response?.TableList || null);
    setModel_1MetricImagesData(model_1response?.ImageList || null);
    setModel_2MetricValuesData(model_2response?.TableList || null);
    setModel_2MetricImagesData(model_2response?.ImageList || null);
    setShowResults(true);
    setBookmarkId(response?.BookmarkId || '');
  };
  const modelsSave = async (model_1Info, model_2Info) => {
    const formObject = dataRef.current.getFieldsValue();
    const value1 = {
      FromTime: dayjs(model_1Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss'),
      ToTime: dayjs(model_1Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss'),
      Metrics: model_1Info.Metrics,
      ModelId: formObject && formObject.ModelName_1 ? formObject.ModelName_1 : '',
      DepReqId:
        modelDeployHistoryData_1 &&
          Array.isArray(modelDeployHistoryData_1) &&
          modelDeployHistoryData_1.filter((item) => item.Default === true) &&
          modelDeployHistoryData_1.filter((item) => item.Default === true)[0] &&
          modelDeployHistoryData_1.filter((item) => item.Default === true)[0]['ReqId']
          ? modelDeployHistoryData_1.filter((item) => item.Default === true)[0]['ReqId']
          : null,
      UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : ''
    };
    const value2 = {
      FromTime: dayjs(model_2Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss'),
      ToTime: dayjs(model_2Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss'),
      Metrics: model_2Info.Metrics,
      ModelId: formObject && formObject.ModelName_2 ? formObject.ModelName_2 : '',
      DepReqId:
        modelDeployHistoryData_2 &&
          Array.isArray(modelDeployHistoryData_2) &&
          modelDeployHistoryData_2.filter((item) => item.Default === true) &&
          modelDeployHistoryData_2.filter((item) => item.Default === true)[0] &&
          modelDeployHistoryData_2.filter((item) => item.Default === true)[0]['ReqId']
          ? modelDeployHistoryData_2.filter((item) => item.Default === true)[0]['ReqId']
          : null,
      UserId: userProfile && userProfile.user && userProfile.user.Id ? userProfile.user.Id : ''
    };
    let response = await createPredictionRequests(APIList.predictionRequest, value1, value2);
    model_1Info = {
      ...model_1Info,
      PredReqId_1:
      response && response.response1 && response.response1.PredReqId
        ? response.response1.PredReqId
        : ''
    };
    model_2Info = {
      ...model_2Info,
      PredReqId_2:
        response && response.response2 && response.response2.PredReqId
          ? response.response2.PredReqId
          : ''
    };
    if (
      model_1Info &&
      model_1Info.PredReqId_1 &&
      model_1Info.PredReqId_1 !== undefined &&
      model_2Info &&
      model_2Info.PredReqId_2 &&
      model_2Info.PredReqId_2 !== undefined
    ) {
      const  final = {
        model_1: {
          ...model_1Info,
          FromTime:
            model_1Info && model_1Info.FromTime && model_1Info.FromTime !== undefined
              ? dayjs(model_1Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss')
              : model_1PredictionRequestList &&
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === model_1Info.PredReqId_1
                ) &&
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === model_1Info.PredReqId_1
                )[0] &&
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === model_1Info.PredReqId_1
                )[0]['FromTime']
                ? dayjs(
                  model_1PredictionRequestList.filter(
                    (item) => item.PredReqId === model_1Info.PredReqId_1
                  )[0]['FromTime']
                )
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss')
                : null,
          ToTime:
            model_1Info && model_1Info.ToTime && model_1Info.ToTime !== undefined
              ? dayjs(model_1Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss')
              : model_1PredictionRequestList &&
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === model_1Info.PredReqId_1
                ) &&
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === model_1Info.PredReqId_1
                )[0] &&
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === model_1Info.PredReqId_1
                )[0]['ToTime']
                ? dayjs(
                  model_1PredictionRequestList.filter(
                    (item) => item.PredReqId === model_1Info.PredReqId_1
                  )[0]['ToTime']
                )
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss')
                : null
        },
        model_2: {
          ...model_2Info,
          FromTime:
            model_2Info && model_2Info.FromTime && model_2Info.FromTime !== undefined
              ? dayjs(model_2Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss')
              : model_2PredictionRequestList &&
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === model_2Info.PredReqId_2
                ) &&
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === model_2Info.PredReqId_2
                )[0] &&
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === model_2Info.PredReqId_2
                )[0]['FromTime']
                ? dayjs(
                  model_2PredictionRequestList.filter(
                    (item) => item.PredReqId === model_2Info.PredReqId_2
                  )[0]['FromTime']
                )
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss')
                : null,
          ToTime:
            model_2Info && model_2Info.FromTime && model_2Info.FromTime !== undefined
              ? dayjs(model_2Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss')
              : model_2PredictionRequestList &&
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === model_2Info.PredReqId_2
                ) &&
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === model_2Info.PredReqId_2
                )[0] &&
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === model_2Info.PredReqId_2
                )[0]['ToTime']
                ? dayjs(
                  model_2PredictionRequestList.filter(
                    (item) => item.PredReqId === model_2Info.PredReqId_2
                  )[0]['ToTime']
                )
                  .utc()
                  .format('YYYY-MM-DD HH:mm:ss')
                : null
        },
        comments:
          formObject.comments && formObject.comments !== undefined ? formObject.comments : ''
      };      bookmarkCreate(final, model_1Info, model_2Info);
      setModel_1Info(model_1Info);
      setModel_2Info(model_2Info);
    }
  };
  const modelSave = async (model_Info, key) => {
    const values = {};
    if (key === 'model__1') {
     const  values = {
        FromTime: moment(model_1Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss'),
        ToTime: moment(model_1Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss'),
        Metrics: model_1Info.Metrics,
        ModelId: formObject && formObject.ModelName_1 ? formObject.ModelName_1 : '',
        DepReqId: modelDeployHistoryData_1 &&
        Array.isArray(modelDeployHistoryData_1) &&
        modelDeployHistoryData_1.filter((item) => item.Default === true) &&
        modelDeployHistoryData_1.filter((item) => item.Default === true)[0] &&
        modelDeployHistoryData_1.filter((item) => item.Default === true)[0]['ReqId']
        ? modelDeployHistoryData_1.filter((item) => item.Default === true)[0]['ReqId']
        : null,
        UserId: userProfile.user?.Id || ''
      };
    } else {
     const  values = {
        FromTime: moment(model_2Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss'),
        ToTime: moment(model_2Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss'),
        Metrics: model_2Info.Metrics,
        ModelId: formObject && formObject.ModelName_2 ? formObject.ModelName_2 : '',
        DepReqId:modelDeployHistoryData_2 &&
        Array.isArray(modelDeployHistoryData_2) &&
        modelDeployHistoryData_2.filter((item) => item.Default === true) &&
        modelDeployHistoryData_2.filter((item) => item.Default === true)[0] &&
        modelDeployHistoryData_2.filter((item) => item.Default === true)[0]['ReqId']
        ? modelDeployHistoryData_2.filter((item) => item.Default === true)[0]['ReqId']
        : null,       
         UserId: userProfile.user?.Id || ''
      };
    }
    let response = await DeployModel(APIList.predictionRequest, values);
    let  Model_1Info = {};
    let Model_2Info = {};
    if (key === 'model__1') {
       Model_1Info = {
        ...model_1Info,
        PredReqId_1: response && response && response.PredReqId ? response.PredReqId : ''
      };
    } else {
       Model_2Info = {
        ...model_2Info,
        PredReqId_2: response && response && response.PredReqId ? response.PredReqId : ''
      };
    }
    const final = {
      model_1: {
        ...Model_1Info,
        FromTime:
        Model_1Info && Model_1Info.FromTime && Model_1Info.FromTime !== undefined
            ? moment(Model_1Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss')
            : model_1PredictionRequestList &&
              model_1PredictionRequestList.filter(
                (item) => item.PredReqId === Model_1Info.PredReqId_1
              ) &&
              model_1PredictionRequestList.filter(
                (item) => item.PredReqId === Model_1Info.PredReqId_1
              )[0] &&
              model_1PredictionRequestList.filter(
                (item) => item.PredReqId === Model_1Info.PredReqId_1
              )[0]['FromTime']
              ? moment(
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === Model_1Info.PredReqId_1
                )[0]['FromTime']
              )
                .utc()
                .format('YYYY-MM-DD HH:mm:ss')
              : null,
        ToTime:
        Model_1Info && Model_1Info.ToTime && Model_1Info.ToTime !== undefined
            ? moment(Model_1Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss')
            : model_1PredictionRequestList &&
              model_1PredictionRequestList.filter(
                (item) => item.PredReqId === Model_1Info.PredReqId_1
              ) &&
              model_1PredictionRequestList.filter(
                (item) => item.PredReqId === Model_1Info.PredReqId_1
              )[0] &&
              model_1PredictionRequestList.filter(
                (item) => item.PredReqId === Model_1Info.PredReqId_1
              )[0]['ToTime']
              ? moment(
                model_1PredictionRequestList.filter(
                  (item) => item.PredReqId === Model_1Info.PredReqId_1
                )[0]['ToTime']
              )
                .utc()
                .format('YYYY-MM-DD HH:mm:ss')
              : null
      },
      model_2: {
        ...Model_2Info,
        FromTime:
        Model_2Info && Model_2Info.FromTime && Model_2Info.FromTime !== undefined
            ? moment(Model_2Info.FromTime).utc().format('YYYY-MM-DD HH:mm:ss')
            : model_2PredictionRequestList &&
              model_2PredictionRequestList.filter(
                (item) => item.PredReqId === Model_2Info.PredReqId_2
              ) &&
              model_2PredictionRequestList.filter(
                (item) => item.PredReqId === Model_2Info.PredReqId_2
              )[0] &&
              model_2PredictionRequestList.filter(
                (item) => item.PredReqId === Model_2Info.PredReqId_2
              )[0]['FromTime']
              ? moment(
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === Model_2Info.PredReqId_2
                )[0]['FromTime']
              )
                .utc()
                .format('YYYY-MM-DD HH:mm:ss')
              : null,
        ToTime:
        Model_2Info && Model_2Info.FromTime && Model_2Info.FromTime !== undefined
            ? moment(Model_2Info.ToTime).utc().format('YYYY-MM-DD HH:mm:ss')
            : model_2PredictionRequestList &&
              model_2PredictionRequestList.filter(
                (item) => item.PredReqId === Model_2Info.PredReqId_2
              ) &&
              model_2PredictionRequestList.filter(
                (item) => item.PredReqId === Model_2Info.PredReqId_2
              )[0] &&
              model_2PredictionRequestList.filter(
                (item) => item.PredReqId === Model_2Info.PredReqId_2
              )[0]['ToTime']
              ? moment(
                model_2PredictionRequestList.filter(
                  (item) => item.PredReqId === Model_2Info.PredReqId_2
                )[0]['ToTime']
              )
                .utc()
                .format('YYYY-MM-DD HH:mm:ss')
              : null
      },
      comments: formObject.comments && formObject.comments !== undefined ? formObject.comments : ''
    };
    bookmarkCreate(final, Model_1Info, Model_2Info);
  };
  const onCheck1 = (key, value) => {
    const model_1Info = model_1Ref.current.getFieldsValue();
    const Model_1Info = {
      ...model_1Info,
      [key]: value
    };
    model_1Ref.current.setFieldsValue(Model_1Info);
    setModel_1Info(Model_1Info);
  };
      // const validateToTime = (_, value) => {
      //   const fromTime = model_1Ref.current &&
      //           model_1Ref.current !== null &&
      //           model_1Ref.current.getFieldValue() &&
      //           model_1Ref.current.getFieldValue('FromTime');
      //   if (!value || !fromTime || dayjs(fromTime).isBefore(dayjs(value))) {
      //     return;
      //   }
      //   message.error('To time must be after from time');
      // };
  const onCheck2 = (key, value) => {
    const model_2Info = model_2Ref.current.getFieldsValue();
    const Model_2Info = {
      ...model_2Info,
      [key]: value
    };
    model_2Ref.current.setFieldsValue(Model_2Info);
    setModel_2Info(Model_2Info);
  };
  const onPrediction_1RequestSubmit = (values) => {
    
    if (values && (values.PredReqId_1 || values.FromTime || values.ToTime)) {
        try {
            let FormObject = dataRef.current?.getFieldsValue() || {}; 
            const formObject = { ...FormObject, ...values };
            dataRef.current?.setFieldsValue(formObject);          
            setFormObject(formObject);
            setPredictionModel_1(false);
        } catch (error) {
            console.error('Error in form submission:', error);
            message.error(translation('An error occurred during submission'));
        }
    } else {
        message.error(translation('Please Input fields'));
    }
};
  const onPrediction_2RequestSubmit = (values) => {
    if ((values && values.PredReqId_2) || values.FromTime || values.ToTime) {
      const FormObject = dataRef.current.getFieldsValue();
      const formObject = { ...FormObject, ...values };
      dataRef.current.setFieldsValue(formObject);
      setFormObject(formObject);
      setPredictionModel_2(false);
    } else {
      message.error(translation('Please Input fields'));
    }
  };
  const translation = (keyword) => {
    const  { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const Model_1PredHistoryColumns = [
    {
      title: translation('Predicted Time From'),
      dataIndex: 'FromTime',
      key: 'FromTime',
      ...getColumnSearchProps('FromTime'),
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted Time To'),
      dataIndex: 'ToTime',
      key: 'ToTime',
      ...getColumnSearchProps('ToTime'),
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status'
    }
  ];
  const Model_2PredHistoryColumns = [
    {
      title: translation('Predicted Time From'),
      dataIndex: 'FromTime',
      key: 'FromTime',
      ...getColumnSearchProps('FromTime'),
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Predicted Time To'),
      dataIndex: 'ToTime',
      key: 'ToTime',
      ...getColumnSearchProps('ToTime'),
      render: (text) => ({
        children: text !== undefined && text !== null ? (
          <div>{moment(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      })
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status'
    }
  ];
  const MetricResultColumns = [
    {
      title: translation('Metrics'),
      dataIndex: 'MetricCode',
      key: 'MetricCode'
    },
    {
      title: translation('Value'),
      dataIndex: 'MetricValue',
      key: 'MetricValue'
    }
  ];
  const validateMessages = {
    required: `${translation('${label}')}${translation('is required!')}`
  };
  const rowSelection1 = {
    selectedRowKeys: selectedRowKeys1,
    onChange: (selectedRowKeys1) => {
      const model_1Info = model_1Ref.current && model_1Ref.current.getFieldsValue();
      const Model_1Info = {
        ...model_1Info,
        PredReqId_1: selectedRowKeys1 && selectedRowKeys1[0] ? selectedRowKeys1[0] : ''
      };
      model_1Ref.current &&
      model_1Ref.current.setFieldsValue({
        PredReqId_1: selectedRowKeys1 && selectedRowKeys1[0] ? selectedRowKeys1[0] : ''
      });
      setModel_1Info(Model_1Info);
      setSelectedRowKeys1(selectedRowKeys1);
    },
    getCheckboxProps: (record) => ({
      name: record.PredReqId
    })
  };
  const rowSelection2 = {
    selectedRowKeys: selectedRowKeys2,
    onChange: (selectedRowKeys2) => {
      const  model_2Info = model_2Ref.current && model_2Ref.current.getFieldsValue();
      const Model_2Info = {
        ...model_2Info,
        PredReqId_2: selectedRowKeys2 && selectedRowKeys2[0] ? selectedRowKeys2[0] : ''
      };
      model_2Ref.current &&
      model_2Ref.current.setFieldsValue({
        PredReqId_2: selectedRowKeys2 && selectedRowKeys2[0] ? selectedRowKeys2[0] : ''
      });
      setModel_2Info(Model_2Info);
      setSelectedRowKeys2(selectedRowKeys2);
    },
    getCheckboxProps: (record) => ({
       //   disabled: record.name === 'Disabled User',
        // Column configuration not to be checked
      name: record.PredReqId
    })
  };
  const path = props.location.pathname.split('/rubus/RbsAnalytics/ModelComparision/');
  const Id = path[1] && base64_decode(path[1]) ? base64_decode(path[1]) : null;
  const formItemLayout = { width: '100%', flex: '50%' };
    return (
      <>
        <StyledSubHeading theme={themeSettings}>
          {translation('Model Details')}
        </StyledSubHeading>
        <StyledForm
      name="ModelDetails"
      ref={dataRef}
      autoComplete="off"
      initialValues={formObject}
      theme={themeSettings}
      layout="horizontal"
      labelCol={{ flex: '200px' }}
      labelAlign="right"
     // onFinish={onFormSubmit}
     // onFinishFailed={onFinishFailed}
      labelWrap
      validateMessages={validateMessages}
      wrapperCol={{ flex: 1 }}
    >
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Form.Item
          label={translation('Model 1')}
          name="ModelName_1"
          rules={[{ required: true }]}
          style={formItemLayout} 
        >
          <Select
            style={{ width: '70%' }}
            disabled
            suffixIcon={
              <ApartmentOutlined
                onClick={() => {
                  (Id && Id !== null) || (BookmarkId && BookmarkId !== '')
                    ? setPredictionModel_1(false)
                    : setPredictionModel_1(true);
                }}
              />
            }
          >
              {modelsList &&
                  modelsList.map((item) => {
                    return (
                      <Option key={item.ModelId} value={item.ModelId}>
                        {item.ModelName}
                      </Option>
                    );
                  })}
          </Select>
        </Form.Item>
        <Form.Item
          label={translation('Model 2')}
          name="ModelName_2"
          rules={[{ required: true }]}
          style={formItemLayout}
        >
          <Select
            style={{ width: '70%' }}
            disabled
            suffixIcon={
              <ApartmentOutlined
                onClick={() => {
                  (Id && Id !== null) || (BookmarkId && BookmarkId !== '')
                    ? setPredictionModel_2(false)
                    : setPredictionModel_2(true);
                }}
              />
            }
          >
              {modelsList &&
                  Array.isArray(modelsList) &&
                  modelsList.map((item) => {
                    return (
                      <Option key={item.ModelId} value={item.ModelId}>
                        {item.ModelName}
                      </Option>
                    );
                  })}
          </Select>
        </Form.Item>
        <Form.Item label={translation('Comments')} name="comments" style={formItemLayout}>
          <TextArea
            style={{ width: '70%' }}
            onChange={(e) => {
            const formObject = dataRef.current.getFieldsValue();
              const FormObject = {
                ...formObject,
                comments: e.target.value
              };
              dataRef.current.getFieldsValue({ ...FormObject });
              setFormObject(FormObject);
            }}
          />
        </Form.Item>
        <Form.Item style={formItemLayout}></Form.Item>
      </div>
      <div style={{ display: 'flex', justifyContent: 'right' }}>
        <Form.Item>
          {model_1Info && model_1Info.PredReqId_1 && model_2Info && model_2Info.PredReqId_2 ? (
              Id && Id !== null ? (
              <Button
                style={{ marginRight: 8 }}
                theme={themeSettings}
                type="primary"
                onClick={() => onFormSaveCompare()}
                data-testid="submitButton"
              >
                {translation('Save')}
              </Button>
            ) : (
              <Button
                style={{ marginRight: 8 }}
                theme={themeSettings}
                type="primary"
                onClick={() => onFormCompare()}
                data-testid="submitButton"
              >
                {translation('Compare')}
              </Button>
            )
          ) : null}
        </Form.Item>
             {props.location.pathname.split('/rubus/RbsAnalytics/ModelComparision/') &&
              props.location.pathname.split('/rubus/RbsAnalytics/ModelComparision/')[1] &&
              props.location.pathname.split('/rubus/RbsAnalytics/ModelComparision/')[1] !==
              undefined ? null : (
          <Form.Item>
            <Button
              style={{ marginRight: 8 }}
              theme={themeSettings}
              type="primary"
              disabled={BookmarkId && BookmarkId !== '' ? true : false}
              onClick={() => onFormSaveCompare()}
              data-testid="submitButton"
            >
              {translation('Save & Compare')}
            </Button>
          </Form.Item>
        )}
        <Form.Item>
          <Button
            style={{ marginRight: 8 }}
            theme={themeSettings}
            type="primary"
            onClick={() => props.navigate('/rubus/RbsAnalytics/ModelComparisionList')}
            data-testid="submitButton"
          >
            {translation('Cancel')}
          </Button>
        </Form.Item>
         {/* <Form.Item>
              <Popconfirm
                placement="topLeft"
                title="Sure to cancel?"
                onConfirm={() => {
                  history.goBack();
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  style={{ marginRight: 8 }}
                  theme={themeSettings}
                  
                >
                  {translation('Cancel')}
                </Button>
              </Popconfirm>
            </Form.Item> */}
      </div>
    </StyledForm>
        {/* </div> */}
        {/* ============================================ Model_1 popup============================================ */}
        <StyledModal
          width="1500px"
          title=""
          open={predictionModel_1}
          onCancel={() => { setPredictionModel_1(false);}}
          closable
          theme={themeSettings}
          footer={[
            <>
              <Button
                key="back"
                onClick={() => {
                 setPredictionModel_1(false);
                  // let formObject = {
                  //   ...formObject,
                  //   ModelName_1: "",
                  // };
                  // let model_1Info = {
                  //   ModelName_1: "",
                  //   PredReqId_1: "",
                  //   FromTime: "",
                  //   ToTime: "",
                  // };
                  // setState({
                  //   model_1Info: { ...model_1Info },
                  //   predictionModel_1: false,
                  //   formObject: { ...formObject },
                  //   selectedRowKeys1: [],
                  // });
                  // model_1Ref.current &&
                  //   model_1Ref.current.setFieldsValue({ ...model_1Info });
                  // dataRef.current &&
                  //   dataRef.current.setFieldsValue({ ...formObject });
                  if ((Id && Id !== null) || (BookmarkId && BookmarkId !== '')) {
                    setPredictionModel_1(false);
                  } else {
                    const FormObject = {};
                   const  formObject = {
                      ...FormObject,
                      ModelName_1: ''
                    };
                    const model_1Info = {
                      ModelName_1: '',
                      PredReqId_1: undefined,
                      FromTime: '',
                      ToTime: ''
                    };
                    setPredictionModel_1(false);
                    setModel_1Info(model_1Info);
                    setFormObject({ ...formObject });
                    setSelectedRowKeys1([]);
                    setFilteredArrayOfModels_2(modelsList);
                    model_1Ref.current &&
                      model_1Ref.current.setFieldsValue(
                        model_1Info
                      );
                    dataRef.current && dataRef.current.setFieldsValue(formObject );
                  }
                }}
              >       
               {model_1Info && model_1Info.PredReqId ? translation('Close') : translation('Cancel')}
                </Button>
                <Button
                  key="submit"
                  type="primary"
                // disabled={(model_1Info &&
                //   model_1Info.PredReqId_1) || (model_1Info &&
                //     model_1Info.FromTime && model_1Info.ToTime) ? false:true}
                onClick={() => model_1Button.current && model_1Button.current.click()}
                >
                  {translation('Save')}
                </Button>
              </>
            ]}
          >
            <StyledForm
              disabled={(Id && Id !== null) || (BookmarkId && BookmarkId !== '') ? true : false}
              name="Prediction Request"
              ref={model_1Ref}
              autoComplete="off"
              initialValues={model_1Info || {}}
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              onFinish={onPrediction_1RequestSubmit}
          //    onFinishFailed={onFinishFailed}
              labelWrap
              validateMessages={validateMessages}
              wrapperCol={{ flex: 1 }}
            >
              <StyledBox>
                <StyledBoxLabel>{translation('Model Details')}</StyledBoxLabel>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px', width: '1500px' }}>
                  <Form.Item
                    label={translation('Model 1')}
                    name="ModelName_1"
                    rules={[{ required: true }]}
                    style={ formItemLayout } 
                  >
                    <Select
                      style={{ width: '70%' }}
                      onChange={(value) => onHandleChange('ModelName_1', value,model_1Info)}
                    >
                    {filteredArrayOfModels_1 &&
                      filteredArrayOfModels_1.map((item) => {
                        return (
                          <Option key={item.ModelId} value={item.ModelId}>
                            {item.ModelName}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="PredReqId_1" style={formItemLayout}></Form.Item>
                </div>
                {model_1Info && model_1Info.ModelName_1 && model_1Info.ModelName_1 !== undefined ? (
                  <Tabs
                    type="card"
                    onTabClick={(value) => {
                      if (value === '2') {
                        if (model_1Info && model_1Info.PredReqId_1) {
                          model_1tab2Confirm.current && model_1tab2Confirm.current.click();
                        } else {
                          getModel_1MetaData(model_1Info && model_1Info.ModelName_1);
                          // setState({ activekey_1: value });
                        }
                      } else if (value === '1') {
                        if (model_1Info && (model_1Info.FromTime || model_1Info.ToTime)) {
                          model_1tab1Confirm.current && model_1tab1Confirm.current.click();
                          setModel_1PredictionRequestList([]);
                        } else {
                          onHandleChange(
                            'ModelName_1',
                            model_1Info && model_1Info.ModelName_1,
                            model_1Info
                          );
                          // setState({ activekey_1: value });
                        }
                      }
                    }}
                    className="TabsText"
                    // activeKey={activekey_1}
                  >
                    <TabPane tab={translation('Existing Prediction')} key="1">
                      <StyledTable size="small"
                        rowSelection={{
                          type: 'radio',
                          ...rowSelection1
                        }}
                        theme={themeSettings}
                        dataSource={
                          model_1PredictionRequestList && Array.isArray(model_1PredictionRequestList)
                            ? model_1PredictionRequestList
                            : []
                        }
                        columns={Model_1PredHistoryColumns}
                      />
                    </TabPane>
                    <TabPane tab={translation('New Prediction')} key="2" 
                    disabled={
                      (Id && Id !== null) || (BookmarkId && BookmarkId !== '') ? true : false

                  }>
                      {newPredictionModel_1 && newPredictionModel_1 === true ?  (
                        <>
                          <StyledBox>
                            <StyledBoxLabel>{translation('Deployment Details')}</StyledBoxLabel>
                            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                              <Form.Item
                                label={translation('Deployed Date')}
                                name="CreatedTime"
                                rules={[{ required: true }]}
                                style={formItemLayout}
                              >
                                <Input disabled style={{ width: '70%' }} />
                              </Form.Item>
                              <Form.Item
                                label={translation('Virtual Environment')}
                                name="Virtualenv"
                                rules={[{ required: true }]}
                                style={formItemLayout}
                              >
                                <Input disabled style={{ width: '70%' }} />
                              </Form.Item>
                            </div>
                          </StyledBox>
                          <StyledBox>
                            <StyledBoxLabel>{translation('Prediction Details')}</StyledBoxLabel>
                            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                              <Form.Item
                                label={translation('Train Period')}
                                name="TrainPeriodFrom"
                                rules={[{ required: true }]}
                                style={formItemLayout}
                              >
                                <Input.Group compact>
                                  <Form.Item name="TrainPeriodFrom" rules={[{ required: true }]}>
                                    <Input style={{ textAlign: 'center', width: 190 }} disabled />
                                  </Form.Item>
                                  <Form.Item rules={[{ required: true }]}>
                                    <Input
                                      style={{
                                        width: 50,
                                        borderLeft: 0,
                                        borderRight: 0,
                                        pointerEvents: 'none'
                                      }}
                                      placeholder={translation('To')}
                                      disabled
                                    />
                                  </Form.Item>
                                  <Form.Item name="TrainPeriodTo" rules={[{ required: true }]}>
                                    <Input
                                      style={{
                                        textAlign: 'center',
                                        borderLeft: 0,
                                        width: 190
                                      }}
                                      disabled
                                    />
                              </Form.Item>
                              </Input.Group>
                            </Form.Item>
                            <Form.Item
                              label={translation('Evaluation Period')}
                              name="EvalPeriodFrom"
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input.Group compact>
                                <Form.Item name="EvalPeriodFrom">
                                  <Input style={{ textAlign: 'center', width: 190 }} disabled />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 50,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('To')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="EvalPeriodTo">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 190
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                            <Form.Item
                              label={translation('Future Prediction')}
                              name="FuturePredRangeFrom"
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input.Group compact>
                                <Form.Item name="FuturePredRangeFrom">
                                  <Input style={{ textAlign: 'center', width: 85 }} disabled />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 50,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('To')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="FuturePredRangeTo">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 85
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 100,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('UOM')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="FuturePredRangeUom">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 110
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                            <Form.Item
                              label={translation('Look back period')}
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input.Group compact>
                                <Form.Item name="LookBackPeriod">
                                  <Input style={{ textAlign: 'center', width: 200 }} disabled />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 100,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('UOM')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="LookBackPeriodUom">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 130
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                            <Form.Item
                              name="FromTime"
                              label={translation('From Time')}
                              // rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <DatePicker
                                // disabled={
                                //   model_1Ref.current.getFieldValue(
                                //     "PredReqId_1"
                                //   ) &&
                                //     model_1Ref.current.getFieldValue(
                                //       "PredReqId_1"
                                //     ) !== undefined
                                //     ? true
                                //     : false
                                // }
                                style={{ width: '70%' }}
                                onChange={(date) => {
                                  const Model_1Info =
                                   model_1Ref.current &&
                                   model_1Ref.current.getFieldsValue();
                                  const model_1Info = {
                                    ...Model_1Info,
                                    FromTime: date
                                  };
                                 model_1Ref.current &&
                                   model_1Ref.current.setFieldsValue(
                                      model_1Info
                                    );
                                  setModel_1Info(model_1Info);
                                }}
                                allowClear={false}
                                showTime={{ format: "HH:mm:ss" }}
                                format="YYYY-MM-DD HH:mm:ss"
                                onOk={(date) => handleDateInputChange(date)}
                                disabledDate={(d) =>
                                  !d ||
                                  d.isAfter(
                                    model_1Ref.current &&
                                      model_1Ref.current !== null &&
                                      model_1Ref.current.getFieldValue() &&
                                      model_1Ref.current.getFieldValue('ToTime')
                                      ? dayjs(
                                        model_1Ref.current.getFieldValue() &&
                                        model_1Ref.current.getFieldValue('ToTime')
                                      ).format('YYYY-MM-DD HH:mm:ss')
                                      : ''
                                  )
                                }
                              />
                            </Form.Item>
                            <Form.Item
                              name="ToTime"
                              label={translation('To Time')}
                              // rules={[{ required: true },
                              //   {validator:validateToTime}
                              // ]}
                              style={formItemLayout}
                            >
                              <DatePicker
                                style={{ width: '70%' }}
                                onChange={(date) => {
                                  const Model_1Info =
                                   model_1Ref.current &&
                                   model_1Ref.current.getFieldsValue();
                                 const model_1Info = {
                                    ...Model_1Info,
                                    ToTime: date
                                  };
                                 model_1Ref.current &&
                                   model_1Ref.current.setFieldsValue(
                                      model_1Info
                                  );
                                 setModel_1Info(model_1Info);
                                }}
                                allowClear={false}
                                showTime={{ format: "HH:mm:ss" }}
                                format="YYYY-MM-DD HH:mm:ss"
                                onOk={(date) => handleDateInputChange(date)}
                                disabledDate={(d) =>
                                  !d ||
                                  d.isBefore(
                                    model_1Ref.current &&
                                      model_1Ref.current !== null &&
                                      model_1Ref.current.getFieldValue() &&
                                      model_1Ref.current.getFieldValue('FromTime')
                                      ? dayjs(
                                        model_1Ref.current.getFieldValue() &&
                                        model_1Ref.current.getFieldValue('FromTime')
                                      ).subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                                      : ''
                                  )
                                }
                                disabledTime={(current) => {
                                  let FromTime = model_1Ref.current &&
                                    model_1Ref.current !== null &&
                                    model_1Ref.current.getFieldValue() &&
                                    model_1Ref.current.getFieldValue('FromTime');
                                  if (!FromTime || !current) {
                                    return {};
                                  }
                                  const disabledHours = [];
                                  const disabledMinutes = [];
                                  const disabledSeconds = [];
                                  if (current.isSame(FromTime, 'day')) {
                                    for (let i = 0; i < FromTime.hour(); i++) {
                                      disabledHours.push(i);
                                    }
                                    if (current.hour() === FromTime.hour()) {
                                      for (let i = 0; i < FromTime.minute(); i++) {
                                        disabledMinutes.push(i);
                                      }
                                      if (current.minute() === FromTime.minute()) {
                                        for (let i = 0; i < FromTime.second(); i++) {
                                          disabledSeconds.push(i);
                                        }
                                      }
                                    }
                                  }
                                  return {
                                    disabledHours: () => disabledHours,
                                    disabledMinutes: () => disabledMinutes,
                                    disabledSeconds: () => disabledSeconds
                                  };
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              name="Metrics"
                              label={translation('Metrics')}
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Tree
                                // disabled={
                                //   model_1Ref.current.getFieldValue(
                                //     "PredReqId_1"
                                //   ) &&
                                //     model_1Ref.current.getFieldValue(
                                //       "PredReqId_1"
                                //     ) !== undefined
                                //     ? true
                                //     : false
                                // }
                                checkable
                                onCheck={(e) => onCheck1('Metrics', e)}
                                switcherIcon={<DownOutlined />}
                                checkedKeys={
                                  model_1Info && model_1Info['Metrics']
                                    ? model_1Info['Metrics']
                                    : ''
                                }
                              >
                                {renderTreeNodes(translation(metricsData))}
                              </Tree>
                            </Form.Item>
                            <Form.Item name="PredReqId_2" style={formItemLayout}></Form.Item>
                            <Form.Item>
                              <Button
                                //ref={predictionButtonRef}
                                htmlType="submit"
                                style={{ display: 'none' }}
                              ></Button>
                            </Form.Item>
                           </div>
                          </StyledBox>
                        </>
                      ) : null}
                    </TabPane>
                  </Tabs>
                ) : null}
                <Form.Item>
                  <Button ref={model_1Button} htmlType="submit" style={{ display: 'none' }}></Button>
                </Form.Item>
              </StyledBox>
            </StyledForm>
            {model_1Info.ModelName_1 ? (
              <div>
                <Popconfirm
                  title={translation('Are you sure to clear the new prediction?')}
                  onConfirm={() => {
                    const Model_1Info = model_1Ref.current.getFieldsValue();
                    const model_1Info = {
                      ...Model_1Info,
                      FromTime: '',
                      ToTime: ''
                    };
                    onHandleChange('ModelName_1', model_1Info.ModelName_1);
                    model_1Ref.current.setFieldsValue(model_1Info );
                    setModel_1Info(model_1Info);
                  }}
                  onCancel={() => {}}
                  okText={translation('Yes')}
                  cancelText={translation('No')}
                >
                  <Form.Item>
                    <Button ref={model_1tab1Confirm} style={{ display: 'none' }}></Button>
                  </Form.Item>
                </Popconfirm>
                <Popconfirm
                  title={translation('Are you sure to clear the existing prediction?')}
                  onConfirm={() => {
                    const Model_1Info = model_1Ref.current.getFieldsValue();
                   const model_1Info = {
                      ...Model_1Info,
                      PredReqId_1: undefined
                    };
                    setModel_1Info(model_1Info);
                    setSelectedRowKeys1([]);
                    getModel_1MetaData(model_1Info && model_1Info.ModelName_1);
                    model_1Ref.current.setFieldsValue(model_1Info );
                  }}
                  onCancel={() => {}}
                  okText={translation('Yes')}
                  cancelText={translation('No')}
                >
                  <Form.Item>
                    <Button ref={model_1tab2Confirm}style={{ display: 'none' }}></Button>
                  </Form.Item>
                </Popconfirm>
              </div>
            ) : null}
          </StyledModal>
        {/* ============================================ Model_2 popup============================================ */}
        <StyledModal
          width="1500px"
          title=""
          open={predictionModel_2}
          onCancel={() => { setPredictionModel_2(false);}}
          // onCancel={setPredictionModel_2(false)}
          closable
          theme={themeSettings}
          footer={[
            <>
            <Button
                key="back"
                onClick={() => {
                 setPredictionModel_2(false);
                  // let formObject = {
                  //   ...formObject,
                  //   ModelName_2: "",
                  // };
                  // let model_2Info = {
                  //   ModelName_2: "",
                  //   PredReqId_2: "",
                  //   FromTime: "",
                  //   ToTime: "",
                  // };
                  // setState({
                  //   model_2Info: { ...model_2Info },
                  //   predictionModel_2: false,
                  //   formObject: { ...formObject },
                  //   selectedRowKeys2: [],
                  // });
                  // model_2Ref.current &&
                  //   model_2Ref.current.setFieldsValue({ ...model_2Info });
                  // dataRef.current &&
                  //   dataRef.current.setFieldsValue({ ...formObject });
                  if ((Id && Id !== null) || (BookmarkId && BookmarkId !== '')) {
                    setPredictionModel_2(false);
                  } else {
                    const formObject = {
                      // ...formObject,
                      ModelName_2: ''
                    };
                    const model_2Info = {
                      ModelName_2: '',
                      PredReqId_2: undefined,
                      FromTime: '',
                      ToTime: ''
                    };
                    setModel_2Info(model_1Info);
                    setPredictionModel_2(false);
                    setFormObject({ ...formObject });
                    setSelectedRowKeys2([]);
                    setFilteredArrayOfModels_1(modelsList);
                    model_2Ref.current &&
                      model_2Ref.current.setFieldsValue(
                        model_2Info
                      );
                    dataRef.current && dataRef.current.setFieldsValue(formObject);
                  }
                }}
              >
                {' '}
                {model_1Info && model_1Info.PredReqId
                  ? translation('Close')
                  : translation('Cancel')}
              </Button>
              <Button
                key="submit"
                type="primary"
                  // disabled={ (model_2Info &&
                //   model_2Info.PredReqId_2) || (model_2Info &&
                //     model_2Info.FromTime && model_2Info.ToTime) ? false : true }
                onClick={() => model_2Button.current && model_2Button.current.click()}
              >
                {translation('Save')}
              </Button>
            </>
          ]}
          >
          <StyledForm
            name="Prediction Request"
            disabled={(Id && Id !== null) || (BookmarkId && BookmarkId !== '') ? true : false}
            ref={model_2Ref}
            autoComplete="off"
            initialValues={model_2Info || {}}
            theme={themeSettings}
            layout="horizontal"
            labelCol={{ flex: '200px' }}
            labelAlign="right"
            onFinish={onPrediction_2RequestSubmit}
       //     onFinishFailed={onFinishFailed}
            labelWrap
            validateMessages={validateMessages}
            wrapperCol={{ flex: 1 }}
          >
            <StyledBox>
              <StyledBoxLabel>{translation('Model Details')}</StyledBoxLabel>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px', width: '1500px' }}>
                <Form.Item
                  label={translation('Model 2')}
                  name="ModelName_2"
                  rules={[{ required: true }]}
                  style={formItemLayout} 
                >
                  <Select
                    style={{ width: '70%' }}
                    onChange={(value) => {onHandleChange('ModelName_2', value,model_2Info);

                    }}
                  >
                    {filteredArrayOfModels_2 && Array.isArray(filteredArrayOfModels_2) &&filteredArrayOfModels_2.map((item) => (
                      <Option key={item.ModelId} value={item.ModelId}>
                        {item.ModelName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="PredReqId_2" style={formItemLayout}></Form.Item>
              </div>
              {model_2Info && model_2Info.ModelName_2 ? (
                <Tabs
                  type="card"
                  className="TabsText"
                    // defaultActiveKey="1"
                    onTabClick={(value) => {
                      if (value === '2') {
                        if (model_2Info && model_2Info.PredReqId_2) {
                          model_2tab2Confirm.current && model_2tab2Confirm.current.click();
                        } else {
                          getModel_2MetaData(model_2Info && model_2Info.ModelName_2);
                          // setState({ activekey_1: value });
                        }
                      } else if (value === '1') {
                        if (model_2Info && (model_2Info.FromTime || model_2Info.ToTime)) {
                          model_2tab1Confirm.current && model_2tab1Confirm.current.click();
                          setModel_2PredictionRequestList([]);
                        } else {
                          onHandleChange(
                            'ModelName_2',
                            model_2Info && model_2Info.ModelName_2,
                            model_1Info
                          );
                          // setState({ activekey_1: value });
                        }
                      }
                    }}
                    >
                  <TabPane tab={translation('Existing Prediction')} key="1">
                    <StyledTable size="small"
                      rowSelection={{
                        type: 'radio',
                        ...rowSelection2
                      }}                      
                      //onChange={handleTableChange}
                      autoResetPage={false}
                      theme={themeSettings}
                      dataSource={
                        model_2PredictionRequestList && Array.isArray(model_2PredictionRequestList)
                          ? model_2PredictionRequestList
                          : []
                      }
                      columns={Model_2PredHistoryColumns}
                    />
                  </TabPane>
                  <TabPane tab={translation('New Prediction')} key="2" disabled={
                      (Id && Id !== null) || (BookmarkId && BookmarkId !== '') ? true : false
                    }>
                    {newPredictionModel_2 && newPredictionModel_2 === true ? (
                      <>
                        <StyledBox>
                          <StyledBoxLabel>{translation('Deployment Details')}</StyledBoxLabel>
                          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                            <Form.Item
                              label={translation('Deployed Date')}
                              name="CreatedTime"
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input disabled style={{ width: '70%' }} />
                            </Form.Item>
                            <Form.Item
                              label={translation('Virtual Environment')}
                              name="Virtualenv"
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input disabled style={{ width: '70%' }} />
                            </Form.Item>
                          </div>
                        </StyledBox>
                        <StyledBox>
                          <StyledBoxLabel>{translation('Prediction Details')}</StyledBoxLabel>
                          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                            <Form.Item
                              label={translation('Train Period')}
                              name="TrainPeriodFrom"
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input.Group compact>
                                <Form.Item name="TrainPeriodFrom" rules={[{ required: true }]}>
                                  <Input style={{ textAlign: 'center', width: 190 }} disabled />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 50,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('To')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="TrainPeriodTo" rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 190
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                              </Input.Group>
                              </Form.Item>
                            <Form.Item
                              label={translation('Evaluation Period')}
                              name="EvalPeriodFrom"
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input.Group compact>
                                <Form.Item name="EvalPeriodFrom">
                                  <Input style={{ textAlign: 'center', width: 190 }} disabled />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 50,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('To')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="EvalPeriodTo">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 190
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                            <Form.Item
                              label={translation('Future Prediction')}
                              name="FuturePredRangeFrom"
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input.Group compact>
                                <Form.Item name="FuturePredRangeFrom">
                                  <Input style={{ textAlign: 'center', width: 85 }} disabled />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 50,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('To')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="FuturePredRangeTo">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 85
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 100,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('UOM')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="FuturePredRangeUom">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 110
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                            <Form.Item
                              label={translation('Look back period')}
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Input.Group compact>
                                <Form.Item name="LookBackPeriod">
                                  <Input style={{ textAlign: 'center', width: 200 }} disabled />
                                </Form.Item>
                                <Form.Item rules={[{ required: true }]}>
                                  <Input
                                    style={{
                                      width: 100,
                                      borderLeft: 0,
                                      borderRight: 0,
                                      pointerEvents: 'none'
                                    }}
                                    placeholder={translation('UOM')}
                                    disabled
                                  />
                                </Form.Item>
                                <Form.Item name="LookBackPeriodUom">
                                  <Input
                                    style={{
                                      textAlign: 'center',
                                      borderLeft: 0,
                                      width: 130
                                    }}
                                    disabled
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                            <Form.Item
                              name="FromTime"
                              label={translation('From Time')}
                              // rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <DatePicker
                                // disabled={
                                //   model_2Ref.current.getFieldValue(
                                //     "PredReqId_2"
                                //   ) &&
                                //     model_2Ref.current.getFieldValue(
                                //       "PredReqId_2"
                                //     ) !== undefined
                                //     ? true
                                //     : false
                                // }
                                style={{ width: '70%' }}
                                allowClear={false}
                                showTime={{ format: "HH:mm:ss" }}
                                format="YYYY-MM-DD HH:mm:ss"
                                onOk={(date) => handleDateInputChange(date)}
                                onChange={(date) => {
                                    const model_2Info =
                                    model_2Ref.current &&
                                    model_2Ref.current.getFieldsValue();
                                  const Model_2Info = {
                                    ...model_2Info,
                                    FromTime: date
                                  };
                                  model_2Ref.current &&
                                    model_2Ref.current.setFieldsValue(
                                      model_2Info
                                    );
                                  setModel_2Info(Model_2Info);
                                }}
                                disabledDate={(d) =>
                                  !d ||
                                  d.isAfter(
                                    model_2Ref.current &&
                                      model_2Ref.current !== null &&
                                      model_2Ref.current.getFieldValue() &&
                                      model_2Ref.current.getFieldValue('ToTime')
                                      ? dayjs(
                                        model_2Ref.current.getFieldValue() &&
                                        model_2Ref.current.getFieldValue('ToTime')
                                      ).format('YYYY-MM-DD HH:mm:ss')
                                      : ''
                                  )
                                }
                              />
                            </Form.Item>
                            <Form.Item
                              name="ToTime"
                              label={translation('To Time')}
                              // rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <DatePicker
                                // disabled={
                                //   model_2Ref.current.getFieldValue(
                                //     "PredReqId_2"
                                //   ) &&
                                //     model_2Ref.current.getFieldValue(
                                //       "PredReqId_2"
                                //     ) !== undefined
                                //     ? true
                                //     : false
                                // }
                                style={{ width: '70%' }}
                                allowClear={false}
                                showTime={{ format: "HH:mm:ss" }}
                                format="YYYY-MM-DD HH:mm:ss"
                                onOk={(date) => handleDateInputChange(date)}
                                onChange={(date) => {
                                  const Model_2Info =
                                    model_2Ref.current &&
                                    model_2Ref.current.getFieldsValue();
                                  const model_2Info = {
                                    ...Model_2Info,
                                    ToTime: date
                                  };
                                  model_2Ref.current &&
                                    model_2Ref.current.setFieldsValue(
                                      model_2Info
                                    );
                                  setModel_2Info(model_2Info);
                                }}
                                // disabledDate={(current)=>{
                                //    return current && current < dayjs( model_2Ref.current &&
                                //     model_2Ref.current !== null &&
                                //     model_2Ref.current.getFieldValue() &&
                                //     model_2Ref.current.getFieldValue('FromTime')).startOf('day');
                                // }}
                                disabledDate={(d) =>
                                  !d ||
                                  d.isBefore(
                                    model_2Ref.current &&
                                      model_2Ref.current !== null &&
                                      model_2Ref.current.getFieldValue() &&
                                      model_2Ref.current.getFieldValue('FromTime')
                                      ? dayjs(
                                        model_2Ref.current.getFieldValue() &&
                                        model_2Ref.current.getFieldValue('FromTime')
                                      ).subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                                      : ''
                                  )
                                }
                                disabledTime={(current) => {
                                  let FromTime = model_2Ref.current &&
                                    model_2Ref.current !== null &&
                                    model_2Ref.current.getFieldValue() &&
                                    model_2Ref.current.getFieldValue('FromTime');
                                  if (!FromTime || !current) {
                                    return {};
                                  }
                                  const disabledHours = [];
                                  const disabledMinutes = [];
                                  const disabledSeconds = [];
                                  if (current.isSame(FromTime, 'day')) {
                                    for (let i = 0; i < FromTime.hour(); i++) {
                                      disabledHours.push(i);
                                    }
                                    if (current.hour() === FromTime.hour()) {
                                      for (let i = 0; i < FromTime.minute(); i++) {
                                        disabledMinutes.push(i);
                                      }
                                      if (current.minute() === FromTime.minute()) {
                                        for (let i = 0; i < FromTime.second(); i++) {
                                          disabledSeconds.push(i);
                                        }
                                      }
                                    }
                                  }
                                  return {
                                    disabledHours: () => disabledHours,
                                    disabledMinutes: () => disabledMinutes,
                                    disabledSeconds: () => disabledSeconds
                                  };
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              name="Metrics"
                              label={translation('Metrics')}
                              rules={[{ required: true }]}
                              style={formItemLayout}
                            >
                              <Tree
                                // style={{ width: '30%' }}
                                // disabled={
                                //   model_2Ref.current.getFieldValue(
                                //     "PredReqId_2"
                                //   ) &&
                                //     model_2Ref.current.getFieldValue(
                                //       "PredReqId_2"
                                //     ) !== undefined
                                //     ? true
                                //     : false
                                // }
                                checkable
                                onCheck={(e) => onCheck2('Metrics', e)}
                                switcherIcon={<DownOutlined />}
                                checkedKeys={
                                  model_2Info && model_2Info['Metrics']
                                    ? model_2Info['Metrics']
                                    : ''
                                }
                              >
                                {renderTreeNodes(metricsData)}
                              </Tree>
                            </Form.Item>
                            <Form.Item name="PredReqId_2" style={formItemLayout}></Form.Item>
                            <Form.Item>
                              <Button
                                //ref={predictionButtonRef}
                                htmlType="submit"
                                style={{ display: 'none' }}
                              ></Button>
                            </Form.Item> 
                            </div>
                        </StyledBox>
                      </>
                    ) : null}
                  </TabPane>
                </Tabs>
              ) : null}
            </StyledBox>
            <Button ref={model_2Button} htmlType="submit" style={{ display: 'none' }}></Button>
            </StyledForm>
            {model_2Info && model_2Info.ModelName_2 && model_2Info.ModelName_2 !== undefined ? (
              <div>
                <Popconfirm
                  title={translation('Are you sure to clear the new prediction?')}
                  onConfirm={() => {
                    const Model_2Info = model_2Ref.current.getFieldsValue();
                    const model_2Info = {
                      ...Model_2Info,
                      FromTime: '',
                      ToTime: ''
                    };
                    onHandleChange('ModelName_2', model_2Info.ModelName_2,model_1Info);
                    model_2Ref.current.setFieldsValue(model_2Info);
                    setModel_2Info(model_2Info);
                  }}
                  onCancel={() => {}}
                  okText={translation('Yes')}
                  cancelText={translation('No')}
                >
                  <Form.Item>
                    <Button ref={model_2tab1Confirm}style={{ display: 'none' }}></Button>
                  </Form.Item>
                </Popconfirm>
                <Popconfirm
                  title={translation('Are you sure to clear the existing prediction?')}
                  onConfirm={() => {
                    const Model_2Info = model_2Ref.current.getFieldsValue();
                    const model_2Info = {
                      ...Model_2Info,
                      PredReqId_2: undefined
                    };
                    setModel_2Info(model_2Info);
                    setSelectedRowKeys2([]);
                    getModel_2MetaData(model_2Info && model_2Info.ModelName_2);


                    model_2Ref.current.setFieldsValue(model_2Info);
                  }}
                  onCancel={() => {}}
                  okText={translation('Yes')}
                  cancelText={translation('No')}
                >
                  <Form.Item>
                    <Button ref={model_2tab2Confirm} style={{ display: 'none' }}></Button>
                  </Form.Item>
                </Popconfirm>
              </div>
            ) : null}
          </StyledModal>
        {/* ============================================  Results ============================================ */}
               {showResults ? (
              <>
                <StyledSubHeading theme={themeSettings}>
                  {translation('Model Comparison Results')}
                </StyledSubHeading>
                <Row
                  gutter={[16, 24]}
                  style={{
                    backgroundColor: '#f5f5f5',
                    border: '1px solid gray',
                    padding: '15px !important'
                  }}
                >
                  <Col className="gutter-row" span={12} style={{ marginTop: '10px' }}>
                    <Layout className="results">
                      <Header>
                        <Title level={5} className="HeaderPart">
                          {translation('Model 1') + ': '}
                          {model_1Info &&
                        modelsList &&
                        modelsList.filter((item) => item.ModelId === model_1Info.ModelName_1) &&
                        modelsList &&
                        modelsList.filter((item) => item.ModelId === model_1Info.ModelName_1)[0] &&
                        modelsList &&
                        modelsList.filter((item) => item.ModelId === model_1Info.ModelName_1)[0][
                        'ModelName'
                        ]}                       
                        </Title>
                        {model_1Info.FromTime && model_1Info.ToTime ? (
                          <>
                            <Title level={5} className="HeaderPart">
                              {translation('From Time') + ': '}
                              {Id && Id !== null
                                ? dayjs(model_1Info.FromTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
                                : dayjs(model_1Info.FromTime).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                            <Title level={5} className="HeaderPart">
                              {translation('To Time') + ': '}
                              {Id && Id !== null
                                ? dayjs(model_1Info.ToTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
                                : dayjs(model_1Info.ToTime).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                          </>
                        ) : model_1PredictionRequestList &&
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        ) &&
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        )[0] &&
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        )[0]['FromTime'] &&
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        )[0]['ToTime'] ? (
                          <>
                            <Title level={5} className="HeaderPart">
                              {translation('From Time') + ' : '}
                              {dayjs(
                           model_1PredictionRequestList.filter(
                            (item) => item.PredReqId === model_1Info.PredReqId_1
                          )[0]['FromTime']
                              ).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                            <Title level={5} className="HeaderPart">
                              {translation('To Time') + ' : '}
                              {dayjs(
                            model_1PredictionRequestList.filter(
                              (item) => item.PredReqId === model_1Info.PredReqId_1
                            )[0]['ToTime']
                              ).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                          </>
                        ) : null}
                        <Title level={5} className="HeaderPart">
                          {translation('Status') + ': '}
                          {model_1Info &&
                        model_1PredictionRequestList &&
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        ) &&
                        model_1PredictionRequestList &&
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        )[0] &&
                        model_1PredictionRequestList &&
                        model_1PredictionRequestList.filter(
                          (item) => item.PredReqId === model_1Info.PredReqId_1
                        )[0]['Status']}
                        </Title>
                      </Header>
                      <Content>
                        {model_1MetricValuesData &&
                      Array.isArray(model_1MetricValuesData) &&
                      model_1MetricValuesData.length !== 0 ? (
                          <StyledTable size="small"
                            pagination={{
                              defaultPageSize: 10,
                              hideOnSinglePage: true
                            }}
                            theme={themeSettings}
                            dataSource={
                              model_1MetricValuesData && Array.isArray(model_1MetricValuesData)
                                ? model_1MetricValuesData
                                : []
                            }
                            columns={MetricResultColumns}
                          />
                        ) : null}
                        {model_1MetricImagesData && Array.isArray(model_1MetricImagesData)
                      ? model_1MetricImagesData.map((item, index) => (
                          <Col key={index} span={8}>
                            <Card title={translation(item.MetricCode)} bordered={false}>
                              <Image
                                width={500}
                                src={`http://192.168.95.23:3001/api/analyticsAttachments/${item.MetricValue.split('/')[0]}/${item.MetricValue.split('/')[1]}`}
                              />
                            </Card>
                          </Col>
                        )): null}
                      </Content>
                    </Layout>
                  </Col>
                  <Col className="gutter-row" span={12} style={{ marginTop: '10px' }}>
                    <Layout className="results">
                      <Header className="results">
                        <Title level={5} className="HeaderPart">
                          {translation('Model 2') + ' : '}
                          {model_2Info &&
                        modelsList &&
                        modelsList.filter((item) => item.ModelId === model_2Info.ModelName_2) &&
                        modelsList &&
                        modelsList.filter((item) => item.ModelId === model_2Info.ModelName_2)[0] &&
                        modelsList &&
                        modelsList.filter((item) => item.ModelId === model_2Info.ModelName_2)[0][
                        'ModelName'
                        ]}                        
                        </Title>
                        {model_2Info.FromTime && model_2Info.ToTime ? (
                          <>
                            <Title level={5} className="HeaderPart">
                              {translation('From Time') + ' : '}
                              {Id && Id !== null
                                ? dayjs(model_2Info.FromTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
                                : dayjs(model_2Info.FromTime).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                            <Title level={5} className="HeaderPart">
                              {translation('To Time') + ' : '}
                              {Id && Id !== null
                                ? dayjs(model_2Info.ToTime).utc().local().format('YYYY-MM-DD HH:mm:ss')
                                : dayjs(model_2Info.ToTime).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                          </>
                        ) : model_2PredictionRequestList &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      ) &&
                      model_2PredictionRequestList &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      )[0] &&
                      model_2PredictionRequestList &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      )[0]['FromTime'] &&
                      model_2PredictionRequestList &&
                      model_2PredictionRequestList.filter(
                        (item) => item.PredReqId === model_2Info.PredReqId_2
                      )[0]['ToTime'] ? (
                          <>
                            <Title level={5} className="HeaderPart">
                              {translation('From Time') + ' : '}
                              {dayjs(
                                model_2PredictionRequestList &&
                                model_2PredictionRequestList.filter(
                                  (item) => item.PredReqId === model_2Info.PredReqId_2
                                )[0]['FromTime']
                              ).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                            <Title level={5} className="HeaderPart">
                              {translation('To Time') + ' : '}
                              {dayjs(
                              model_2PredictionRequestList &&
                              model_2PredictionRequestList.filter(
                                (item) => item.PredReqId === model_2Info.PredReqId_2
                              )[0]['ToTime']
                              ).format('YYYY-MM-DD HH:mm:ss')}
                            </Title>
                          </>
                        ) : null}
                        <Title level={5} className="HeaderPart">
                          {translation('Status') + ' : '}
                          {model_2Info &&
                        model_2PredictionRequestList &&
                        model_2PredictionRequestList.filter(
                          (item) => item.PredReqId === model_2Info.PredReqId_2
                        ) &&
                        model_2PredictionRequestList &&
                        model_2PredictionRequestList.filter(
                          (item) => item.PredReqId === model_2Info.PredReqId_2
                        )[0] &&
                        model_2PredictionRequestList &&
                        model_2PredictionRequestList.filter(
                          (item) => item.PredReqId === model_2Info.PredReqId_2
                        )[0]['Status']}
                        </Title>
                      </Header>
                      <Content
                        style={{
                          marginTop: '10px !important',
                          border: '1px solid gray'
                        }}
                      >
                        {model_2MetricValuesData &&
                      Array.isArray(model_2MetricValuesData) &&
                      model_2MetricValuesData.length !== 0 ?  (
                          <StyledTable size="small"
                            pagination={{
                              defaultPageSize: 10,
                              hideOnSinglePage: true
                            }}
                            theme={themeSettings}
                            dataSource={
                              model_2MetricValuesData && Array.isArray(model_2MetricValuesData)
                                ? model_2MetricValuesData
                                : ['undefined']
                            }
                            columns={MetricResultColumns}
                          />
                        ) : null}
                        {model_2MetricImagesData && Array.isArray(model_2MetricImagesData)
                      ? model_2MetricImagesData.map((item, index) => (
                          <Col key={index} span={8}>
                            <Card title={translation(item.MetricCode)} bordered={false}>
                              <Image
                                width={500}
                                src={`http://192.168.95.23:3001/api/analyticsAttachments/${item.MetricValue.split('/')[0]}/${item.MetricValue.split('/')[1]}`}
                              />
                            </Card>
                          </Col>
                        ))
                        : null}
                      </Content>
                    </Layout>
                  </Col>
                </Row>
              </>
              ) : (
              <Result
                icon={<SmileOutlined />}
                title={translation('Please Provide Model Details To Compare!')}
              />
              )} 
      </>
    );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(Model_Comparision);
